// removed by extract-text-webpack-plugin
module.exports = {"Container":"src-containers-LandingPage-__LandingPage-module___Container","Greeting":"src-containers-LandingPage-__LandingPage-module___Greeting"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/LandingPage/LandingPage.module.css
// module id = 1212
// module chunks = 1